import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "info-message-block" }

import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BalancesInfoMessageBlock',
  props: {
  authenticatedUser: { type: Boolean, required: true },
},
  setup(__props) {

const props = __props;

const infoMessage = computed(() => {
  if (!props.authenticatedUser) {
    const loginToSee = 'Login to see balances';

    return loginToSee;
  }
  return 'No balances';
});

return (_ctx: any,_cache: any) => {
  const _component_ot_icon = _resolveComponent("ot-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ot_icon, {
      name: __props.authenticatedUser ? 'layer' : 'lock-circle',
      "inherit-stroke": true
    }, null, 8, ["name"]),
    _createElementVNode("span", null, _toDisplayString(infoMessage.value), 1)
  ]))
}
}

})